import Menu from "@mui/icons-material/Menu";
import {
  Badge,
  Menu as Menu2,
  Box,
  Button,
  Dropdown,
  IconButton,
  MenuButton,
  MenuItem,
} from "@mui/joy";
import CloseIcon from "@mui/icons-material/Close";
import {
  Collapse,
  Dialog,
  DialogContent,
  Paper,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import logo from "./../assets/image/LOGO 4.3.png";
import { Link, useNavigate } from "react-router-dom";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useSelector } from "react-redux";
import publicar from "./../assets/image/publicar.jpg";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const carrito = useSelector((state) => state.carrito?.carro ?? []);

  return (
    <Paper
      elevation={10}
      sx={{
        marginTop: -3,
        position: "fixed",
        width: "100%",
        zIndex: 3,
        background: "#FFFFFF",
      }}
    >
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        sx={{
          width: "96%",
          padding: "0% 2% 0% 2%",
          // background: "rgba(255, 255, 255, 0.8)",
        }}
      >
        <Box
          padding={"10px"}
          sx={{ display: "flex", alignItems: "center", gap: 3 }}
        >
          <Button
            variant="plain"
            size="lg"
            onClick={() => navigate("/")}
            component={Link}
            to={"/"}
          >
            <img alt="logo" src={logo} width={"100px"} />
          </Button>
          <Box
            sx={{ display: { xs: "none", sm: "none", md: "none", lg: "flex" } }}
          >
            <Button
              variant="solid"
              size="md"
              component={Link}
              to={"https://clientes.publimed.net"}
            >
              <Typography
                fontWeight={"bold"}
                sx={{ fontSize: { xs: "10px", sm: "15px" } }}
                textAlign={"center"}
              >
                Portal de Clientes
              </Typography>
            </Button>
          </Box>
        </Box>
        <Box padding={"10px"} display={{ xs: "none", sm: "none", md: "flex" }}>
          <Button
            variant="plain"
            size="lg"
            onClick={() => navigate("/publicaciones")}
            component={Link}
            to={"/publicaciones"}
          >
            <Typography fontWeight={"bold"} variant="h6">
              Publicaciones médicas
            </Typography>
          </Button>
          <Button
            variant="plain"
            size="lg"
            onClick={() => navigate("/cursos")}
            component={Link}
            to={"/cursos"}
          >
            <Typography fontWeight={"bold"} variant="h6">
              Cursos
            </Typography>
          </Button>
          <Button
            variant="plain"
            size="lg"
            onClick={() => navigate("/carrito")}
            component={Link}
            to={"/carrito"}
          >
            <Typography fontWeight={"bold"} variant="h6" pr={1}>
              Carrito
            </Typography>
            <Badge badgeContent={carrito?.length ?? 0} color="danger">
              <ShoppingCartIcon />
            </Badge>
          </Button>
          <Button
            component={Link}
            to={"/nosotros"}
            variant="plain"
            size="lg"
            onClick={() => navigate("/nosotros")}
          >
            <Typography fontWeight={"bold"} variant="h6">
              Nosotros
            </Typography>
          </Button>
        </Box>
        <Box padding={"10px"} display={{ xs: "flex", sm: "flex", md: "none" }}>
          <Button
            variant="plain"
            size="lg"
            onClick={() => navigate("/carrito")}
            component={Link}
            to={"/carrito"}
          >
            <Badge badgeContent={carrito?.length ?? 0} color="danger">
              <ShoppingCartIcon />
            </Badge>
          </Button>
          <Dropdown>
            <MenuButton
              slots={{ root: IconButton }}
              // slotProps={{ root: { variant: "outlined", color: "neutral" } }}
            >
              <Menu sx={{ fontSize: "36px" }} />
            </MenuButton>
            <Menu2>
              <MenuItem>
                <Button
                  variant="plain"
                  size="lg"
                  onClick={() => {
                    setOpen(false);
                    navigate("/publicaciones");
                  }}
                >
                  <Typography fontWeight={"bold"}>
                    Publicaciones médicas
                  </Typography>
                </Button>
              </MenuItem>
              <MenuItem>
                <Button
                  variant="plain"
                  size="lg"
                  onClick={() => {
                    setOpen(false);
                    navigate("/cursos");
                  }}
                >
                  <Typography fontWeight={"bold"}>Cursos</Typography>
                </Button>
              </MenuItem>
              <MenuItem>
                <Button
                  variant="plain"
                  size="lg"
                  onClick={() => {
                    setOpen(false);
                    navigate("/carrito");
                  }}
                >
                  <Typography fontWeight={"bold"} pr={1}>
                    Carrito
                  </Typography>
                  <Badge badgeContent={carrito?.length ?? 0} color="danger">
                    <ShoppingCartIcon />
                  </Badge>
                </Button>
              </MenuItem>
              <MenuItem>
                <Button
                  variant="plain"
                  size="lg"
                  onClick={() => {
                    setOpen(false);
                    navigate("/nosotros");
                  }}
                >
                  <Typography fontWeight={"bold"}>Nosotros</Typography>
                </Button>
              </MenuItem>
              <MenuItem>
                <Button
                  variant="outlined"
                  size="lg"
                  component={Link}
                  to={"https://clientes.publimed.net"}
                >
                  <Typography fontWeight={"bold"}>
                    Portal de Clientes
                  </Typography>
                </Button>
              </MenuItem>
            </Menu2>
          </Dropdown>
        </Box>
      </Box>
    </Paper>
  );
};
